<template>
  <v-container fluid>
    <div class="align-self-start fill-width pa-2">
      <div
        v-for="(item, index) in $t('panel.accountPage.userInfo')"
        :key="item.value"
      >
        <v-card elevation="0" class="d-flex align-center justify-space-between">
          <v-card-text class="width-auto">{{ item.text }}</v-card-text>
          <v-card-text class="width-auto">{{
            itemDetailValue(item.value)
          }}</v-card-text>
        </v-card>
        <v-divider
          v-if="index !== $t('panel.accountPage.userInfo').length - 1"
          class="mx-2"
        />
      </div>
    </div>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "account-info",
  computed: {
    ...mapGetters({
      userInfo: "userInfo/GET_USERINFO"
    })
  },
  methods: {
    itemDetailValue(val) {
      return this.userInfo[val];
    }
  }
};
</script>

<style lang="scss" scoped>
@import "AccountInfo";
</style>
